module.exports = __webpack_public_path__ + "img/icon-send.ed504f1d.svg";